import SVGAtom from "~/components/Atoms/SVGAtom/SVGAtom";
import { invertHexColor } from "~/utils/invertColor";

type Props = {
  logoIcon?: React.ComponentProps<typeof SVGAtom>;
  buttonText: string;
  onButtonClick: () => Promise<void>;
  buttonColor?: string;
};

export const LogInButton = (props: Props) => {
  return (
    <button
      onClick={() => props.onButtonClick()}
      className="shadow-login flex h-[66px] w-full items-center justify-center gap-[22px] rounded-[12px]"
      style={{ backgroundColor: props.buttonColor ?? "#fff" }}
    >
      {props.logoIcon && <SVGAtom {...props.logoIcon} />}
      <p
        className="text-center text-[20px] font-semibold leading-[24px]"
        style={{
          color: props.buttonColor ? invertHexColor(props.buttonColor) : "#000",
        }}
      >
        {props.buttonText}
      </p>
    </button>
  );
};
